import { SingleHandoverAppointmentModel } from "../../../services/api/types/shiftHandover/models/SingleHandoverAppointmentModel";
import { ResidentModel } from "../../../services/api/types/residents/models/ResidentModel";
import { Text } from "react-native";
import { format } from "date-fns";
import { TaskItem } from "./TaskItem";

export interface Props {
  residents: ResidentModel[];
  appointment: SingleHandoverAppointmentModel;
  onRowPress: (
    residentId: number | undefined,
    appointment: SingleHandoverAppointmentModel,
  ) => void;
  handleMarkAsDone: (appointment) => void;
  isOverdueCompleted: boolean | undefined;
  allResidents: boolean;
}

export function OverdueTaskItem({
  residents,
  appointment,
  onRowPress,
  handleMarkAsDone,
  isOverdueCompleted,
  allResidents,
}: Props) {
  const preparationNeeded = !!appointment.preparation_needed;

  return (
    <TaskItem
      residents={residents}
      onRowPress={() => {
        const residentId =
          residents?.length === 1 ? residents[0]?.id : undefined;
        onRowPress(residentId, appointment);
      }}
      backgroundColourClass="bg-warning-0"
      handleMarkAsDone={() => handleMarkAsDone(appointment)}
      isCompleted={isOverdueCompleted}
      renderContent={() => (
        <Text className="text-base">
          {`${appointment?.title} (Missed at ${appointment?.starts_at ? format(appointment.starts_at, "dd-MM-yyyy HH:mm") : ""})`}
        </Text>
      )}
      allResidents={allResidents}
      preparationNeeded={preparationNeeded}
    ></TaskItem>
  );
}
